// extracted by mini-css-extract-plugin
export default {"cssloadContainer":"GlobalLoader_cssloadContainer__MZfKG","spinnerPosition":"GlobalLoader_spinnerPosition__gyVcV"};